import type { GetSimilarCandidatesSeekOrCombinedQuery } from '../data/GetSimilarCandidatesSeekOrCombined.generated';
import type { ProfileFieldsFragment } from '../data/ProfileFields.fragment.generated';
import type { SeedProfileFieldsFragment } from '../data/SeedProfileFields.fragment.generated';

export type SimilarCandidatesQueryResult =
  GetSimilarCandidatesSeekOrCombinedQuery['seekOrCombinedProfiles'];

export interface SimilarCandidatesView {
  isError: boolean;
  count: number;
  profiles: ProfileFieldsFragment[];
  seedProfile: SeedProfileFieldsFragment | null;
}

const emptyView: SimilarCandidatesView = {
  isError: false,
  count: 0,
  profiles: [],
  seedProfile: null,
};

export function readSimilarCandidatesResult(
  result: SimilarCandidatesQueryResult | null | undefined,
): SimilarCandidatesView {
  if (!result) {
    return emptyView;
  }

  switch (result.__typename) {
    case 'SimilarCandidatesSuccessResponse':
      return {
        isError: false,
        count: result.result.totalCount,
        profiles: result.result.edges.map((edge) => edge.node),
        seedProfile: result.result.seedProfile ?? null,
      };
    case 'SimilarCandidatesNoSimilarProfilesSuccessResponse':
      return emptyView;
    case 'ResponseError':
      return { ...emptyView, isError: true };
    default:
      return readUnexpectedResult(result);
  }
}

function readUnexpectedResult(_result: never): SimilarCandidatesView {
  return { ...emptyView, isError: true };
}
